import { Category } from "interfaces";
import React from "react";
import cls from "./v1.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

type Props = {
  data: Category;
  parent?: string;
};

export default function CategoryCard({ data }: Props) {
  const { query } = useRouter();
  const handleQuery = (categoryId?: number) => {
    if (Number(query?.category_id) === categoryId) {
      return { ...query, category_id: undefined };
    }
    return { ...query, category_id: categoryId };
  };
  return (
    <Link
      href={{
        query: handleQuery(data?.id),
      }}
    >
      <div
        className={`${cls.card} ${
          Number(query?.category_id) === data?.id ? cls.active : ""
        }`}
      >
        <Image
          width={30}
          height={30}
          className={cls.img}
          alt={data?.translation?.title}
          src={data?.img || ""}
        />
        <div className={cls.text}>{data?.translation?.title}</div>
      </div>
    </Link>
  );
}
